@let isMobile = isMobile$ | async;

<div
	[ngClass]="{
		'flex-row-reverse justify-between p-5': isHorizontal(),
		'flex-col justify-center p-7': !isHorizontal(),
	}"
	class="card flex items-center justify-center gap-2"
	data-test-id="rating"
>
	<div
		[ngClass]="{
			'mx-8': isHorizontal(),
		}"
		class="relative"
	>
		<ng-container [ngTemplateOutlet]="laurel" />
		<span
			[ngClass]="{
				'md:text-8xl': !isHorizontal(),
			}"
			class="text-4xl tracking-tighter text-accent-100"
			data-test-id="score"
		>
			{{ score() | number: '1.1-1' : language() }}
		</span>
		<ng-container
			[ngTemplateOutlet]="laurel"
			[ngTemplateOutletContext]="{ invert: true }"
		/>
	</div>
	<div
		[ngClass]="{
			'text-center': !isHorizontal(),
		}"
		class="flex flex-col gap-2"
	>
		<vp-social-proof
			[numberOfRatings]="numberOfRatings()"
			[rating]="score()"
			[showOnlyText]="true"
			[size]="isMobile ? 'sm' : 'base'"
		/>
	</div>
</div>

<ng-template #laurel let-invert="invert">
	<div
		[ngClass]="{
			'-right-8 -scale-x-100': invert,
			'-left-8': !invert,
			'md:-right-12': invert && !isHorizontal(),
			'md:-left-12': !invert && !isHorizontal(),
		}"
		class="absolute top-0"
	>
		<svg-icon
			[ngClass]="{
				'md:size-20': !isHorizontal(),
			}"
			class="inline-block size-12 text-accent-100 [mask-image:linear-gradient(to_bottom,rgba(0,0,0,0.2),rgba(255,0,0,0))]"
			src="assets/icons/illustration-laurel.svg"
		/>
	</div>
</ng-template>
